import axios from "axios";
import { stringify } from "qs";
const DEFAULT_TIMEOUT = 1e4;
const API = (apiUrl, config) => {
  return axios.create({
    baseURL: apiUrl || "/api",
    timeout: DEFAULT_TIMEOUT,
    paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) },
    withCredentials: false,
    ...config
  });
};
export {
  API,
  DEFAULT_TIMEOUT
};
